import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { isShowButtonLog, openAiLogDetail, updateLogURL } from '../handler/AiLogDetailHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

AiLogDetail.propTypes = {
    chatThreadId: PropTypes.string,
    listMessageContent: PropTypes.array,
    currentUserDetail: PropTypes.object,
    corporationDetail: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    isAiAssistantLog: PropTypes.bool
};

export default function AiLogDetail({
    chatThreadId,
    listMessageContent,
    currentUserDetail,
    corporationDetail,
    projectInuseDetail,
    isAiAssistantLog = false
}) {
    useTranslationSubscription();
    const [logUrl, setLogUrl] = useState('');

    useEffect(() => {
        if (!chatThreadId) return;
        let isMounted = true;

        updateLogURL({chatThreadId, setLogUrl, isMounted});

        return () => {
            isMounted = false;
        };
    }, [chatThreadId]);

    const handleOpenLog = useCallback(async () => {
        return await openAiLogDetail(chatThreadId);
    }, [chatThreadId]);

    if (
        !isShowButtonLog({corporationDetail, projectInuseDetail, currentUserDetail, listMessageContent}) ||
        !logUrl ||
        isAiAssistantLog
    ) {
        return null;
    }

    return (
        <button
            className="btn-reset-default ai-log-url-btn"
            onClick={handleOpenLog}
        >
            {trI18n('DETAIL')}
        </button>
    );
}
